import { dateStringToTimestamp, isoToTimestamp } from './timestamp';

const { PaginationRequest } = require('./proto/acompanha/common/v1/common_pb');

function paginationFromQuery(query) {
    const pagination = new PaginationRequest();
    const page = parseInt(query.page, 10);
    const limit = parseInt(query.limit, 10);
    if (page > 0) {
        pagination.setPage(page);
    }
    if (limit > 0) {
        pagination.setLimit(limit);
    }
    if (query.q) {
        pagination.setQ(String(query.q));
    }
    return pagination;
}

function optionalIsoTimestamp(value) {
    if (!value) {
        return null;
    }
    const trimmed = String(value).trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
        return dateStringToTimestamp(trimmed);
    }
    return isoToTimestamp(trimmed);
}

function customerRefFromRest(data) {
    const { CustomerRef } = require('./proto/acompanha/common/v1/common_pb');
    if (!data || typeof data !== 'object') {
        return null;
    }
    const ref = new CustomerRef();
    const id = data.id || data.uuid || data.customer_uuid;
    if (id) {
        ref.setId(String(id));
    }
    if (data.name) {
        ref.setName(String(data.name));
    }
    if (data.phone) {
        ref.setPhone(String(data.phone));
    }
    if (data.email) {
        ref.setEmail(String(data.email));
    }
    if (data.document) {
        ref.setDocument(String(data.document));
    }
    if (data.category && typeof ref.setCategory === 'function') {
        ref.setCategory(String(data.category));
    }
    if (data.address && typeof ref.setAddress === 'function') {
        ref.setAddress(String(data.address));
    }
    if (data.address_number && typeof ref.setAddressNumber === 'function') {
        ref.setAddressNumber(String(data.address_number));
    }
    if (data.address_complement && typeof ref.setAddressComplement === 'function') {
        ref.setAddressComplement(String(data.address_complement));
    }
    if (data.neighborhood && typeof ref.setNeighborhood === 'function') {
        ref.setNeighborhood(String(data.neighborhood));
    }
    if (data.city && typeof ref.setCity === 'function') {
        ref.setCity(String(data.city));
    }
    if (data.state && typeof ref.setState === 'function') {
        ref.setState(String(data.state));
    }
    if (data.zip_code && typeof ref.setZipCode === 'function') {
        ref.setZipCode(String(data.zip_code));
    }
    return ref;
}

function salesChannelRefFromRest(data) {
    const { SalesChannelRef } = require('./proto/acompanha/common/v1/common_pb');
    if (!data || typeof data !== 'object') {
        return null;
    }
    const id = data.id || data.uuid;
    const name = data.name;
    if (!id && !name) {
        return null;
    }
    const ref = new SalesChannelRef();
    if (name) {
        ref.setName(String(name));
    }
    if (id) {
        ref.setId(String(id));
    }
    if (typeof ref.setKind === 'function' && data.kind) {
        ref.setKind(String(data.kind));
    }
    if (typeof ref.setHoldsPayout === 'function' && data.holds_payout != null) {
        ref.setHoldsPayout(Boolean(data.holds_payout));
    }
    return ref;
}

function shippingMethodRefFromRest(data) {
    const { ShippingMethodRef } = require('./proto/acompanha/common/v1/common_pb');
    if (!data || typeof data !== 'object') {
        return null;
    }
    const ref = new ShippingMethodRef();
    if (data.name) {
        ref.setName(String(data.name));
    }
    if (data.cost != null) {
        ref.setCost(Number(data.cost));
    }
    if (data.delivery_days != null) {
        ref.setDeliveryDays(Number(data.delivery_days));
    }
    if (data.deadline) {
        ref.setDeadline(String(data.deadline));
    }
    return ref;
}

function checkoutProductFromRest(data) {
    const { CheckoutProduct } = require('./proto/acompanha/common/v1/common_pb');
    if (!data || typeof data !== 'object') {
        return null;
    }
    const p = new CheckoutProduct();
    const id = data.id || data.uuid || data.product_uuid;
    if (id) {
        p.setId(String(id));
    }
    if (data.name) {
        p.setName(String(data.name));
    }
    if (data.quantity != null) {
        p.setQuantity(Number(data.quantity));
    }
    if (data.base_price != null) {
        p.setBasePrice(Number(data.base_price));
    }
    if (data.cost_price != null) {
        p.setCostPrice(Number(data.cost_price));
    }
    if (typeof p.setKind === 'function' && data.kind) {
        p.setKind(String(data.kind));
    }
    return p;
}

function paymentMethodFromRest(data) {
    const { PaymentMethod } = require('./proto/acompanha/common/v1/common_pb');
    if (!data || typeof data !== 'object') {
        return null;
    }
    const p = new PaymentMethod();
    if (data.name) {
        p.setName(String(data.name));
    }
    if (data.installments != null) {
        p.setInstallments(Number(data.installments));
    }
    if (data.amount != null) {
        p.setAmount(Number(data.amount));
    }
    const ts = optionalIsoTimestamp(data.payment_date);
    if (ts) {
        p.setPaymentDate(ts);
    }
    return p;
}

function paymentDetailsFromRest(data) {
    const { PaymentDetails } = require('./proto/acompanha/common/v1/common_pb');
    if (!data || typeof data !== 'object') {
        return null;
    }
    const p = new PaymentDetails();
    if (data.paid != null) {
        p.setPaid(Boolean(data.paid));
    }
    const ts = optionalIsoTimestamp(data.payment_date);
    if (ts) {
        p.setPaymentDate(ts);
    }
    return p;
}

function jobFilamentsFromRest(filaments) {
    const { JobFilament } = require('./proto/acompanha/jobs/v1/jobs_pb');
    if (!Array.isArray(filaments)) {
        return [];
    }
    return filaments
        .filter((f) => f && ((f.filament_uuid || '').trim() || (f.color || '').trim()))
        .map((f) => {
            const row = new JobFilament();
            if (f.color) {
                row.setColor(String(f.color).trim());
            }
            if (f.filament_uuid) {
                row.setFilamentUuid(String(f.filament_uuid).trim());
                row.setGrams(Number(f.grams) || 0);
            }
            return row;
        });
}

function metadataToJson(metadata) {
    if (metadata == null) {
        return '';
    }
    if (typeof metadata === 'string') {
        return metadata;
    }
    try {
        return JSON.stringify(metadata);
    } catch {
        return '';
    }
}

function measuresToJson(measures) {
    if (measures == null) {
        return '';
    }
    if (typeof measures === 'string') {
        return measures;
    }
    try {
        return JSON.stringify(measures);
    } catch {
        return '';
    }
}

function replacementPartsFromRest(parts) {
    const { ReplacementPart } = require('./proto/acompanha/printer_maintenances/v1/printer_maintenances_pb');
    if (!Array.isArray(parts)) {
        return [];
    }
    return parts
        .map((part) => {
            if (typeof part === 'string' && part.trim()) {
                const row = new ReplacementPart();
                row.setName(part.trim());
                return row;
            }
            const name = String(part?.name || '').trim();
            if (name) {
                const row = new ReplacementPart();
                row.setName(name);
                const cents = Number(part.value_cents ?? part.valueCents ?? 0);
                if (Number.isFinite(cents) && cents > 0) {
                    row.setValueCents(Math.round(cents));
                }
                const stockUuid = String(part.stock_part_uuid || part.stockPartUuid || '').trim();
                if (stockUuid) {
                    row.setStockPartUuid(stockUuid);
                }
                return row;
            }
            return null;
        })
        .filter(Boolean);
}

export function buildPaginationRequest(query) {
    return paginationFromQuery(query || {});
}

export function buildLoginRequest(data) {
    const { LoginRequest } = require('./proto/acompanha/auth/v1/auth_pb');
    const req = new LoginRequest();
    req.setEmail(String(data?.email || '').trim());
    req.setPassword(String(data?.password || ''));
    return req;
}

export function buildRegisterRequest(data) {
    const { RegisterRequest } = require('./proto/acompanha/auth/v1/auth_pb');
    const req = new RegisterRequest();
    req.setName(String(data?.name || '').trim());
    req.setEmail(String(data?.email || '').trim());
    req.setPassword(String(data?.password || ''));
    req.setStoreName(String(data?.store_name || '').trim());
    const planUUID = String(data?.subscription_plan_uuid || data?.planId || data?.plan_id || '').trim();
    if (planUUID && typeof req.setSubscriptionPlanUuid === 'function') {
        req.setSubscriptionPlanUuid(planUUID);
    }
    return req;
}

export function buildUpdateProfileRequest(data) {
    const { UpdateProfileRequest } = require('./proto/acompanha/account/v1/account_pb');
    const req = new UpdateProfileRequest();
    if (data?.name != null) {
        req.setName(String(data.name));
    }
    if (data?.email != null) {
        req.setEmail(String(data.email));
    }
    if (data?.whatsapp != null) {
        req.setWhatsapp(String(data.whatsapp));
    }
    if (data?.site != null) {
        req.setSite(String(data.site));
    }
    if (data?.instagram != null) {
        req.setInstagram(String(data.instagram));
    }
    if (data?.tiktok != null) {
        req.setTiktok(String(data.tiktok));
    }
    if (data?.store_name != null) {
        req.setStoreName(String(data.store_name));
    }
    if (data?.address != null) {
        req.setAddress(String(data.address));
    }
    if (data?.address_number != null) {
        req.setAddressNumber(String(data.address_number));
    }
    if (data?.address_complement != null) {
        req.setAddressComplement(String(data.address_complement));
    }
    if (data?.neighborhood != null) {
        req.setNeighborhood(String(data.neighborhood));
    }
    if (data?.zip_code != null) {
        req.setZipCode(String(data.zip_code));
    }
    if (data?.city != null) {
        req.setCity(String(data.city));
    }
    if (data?.state != null) {
        req.setState(String(data.state));
    }
    return req;
}

export function buildUpdatePasswordRequest(data) {
    const { UpdatePasswordRequest } = require('./proto/acompanha/account/v1/account_pb');
    const req = new UpdatePasswordRequest();
    req.setCurrentPassword(String(data?.current_password || ''));
    req.setNewPassword(String(data?.new_password || ''));
    return req;
}

export function buildUpdateAvatarRequest(data) {
    const { UpdateAvatarRequest } = require('./proto/acompanha/account/v1/account_pb');
    const req = new UpdateAvatarRequest();
    req.setImage(String(data?.image || ''));
    return req;
}

export function buildListJobsRequest(query) {
    const { ListJobsRequest } = require('./proto/acompanha/jobs/v1/jobs_pb');
    const req = new ListJobsRequest();
    req.setPagination(buildPaginationRequest(query));
    if (query.printer_uuid) {
        req.setPrinterUuid(String(query.printer_uuid));
    }
    if (query.status) {
        req.setStatus(String(query.status));
    }
    const from = optionalIsoTimestamp(query.finished_from);
    const to = optionalIsoTimestamp(query.finished_to);
    if (from) {
        req.setFinishedFrom(from);
    }
    if (to) {
        req.setFinishedTo(to);
    }
    return req;
}

export function buildPrinterStatsRequest(query) {
    const { PrinterStatsRequest } = require('./proto/acompanha/jobs/v1/jobs_pb');
    const req = new PrinterStatsRequest();
    if (query.q) {
        req.setQ(String(query.q));
    }
    if (query.printer_uuid) {
        req.setPrinterUuid(String(query.printer_uuid));
    }
    if (query.status) {
        req.setStatus(String(query.status));
    }
    const from = optionalIsoTimestamp(query.finished_from);
    const to = optionalIsoTimestamp(query.finished_to);
    if (from) {
        req.setFinishedFrom(from);
    }
    if (to) {
        req.setFinishedTo(to);
    }
    return req;
}

// Numeric job fields are optional in the proto, so only the ones actually sent
// are written. Setting them unconditionally would zero whatever a partial update
// left out.
function setOptionalNumber(req, setter, value) {
    if (value == null || value === '') {
        return;
    }
    req[setter](Number(value) || 0);
}

function fillJobMutation(req, data) {
    const d = data || {};
    req.setPrinterUuid(String(d.printer_uuid || ''));
    req.setFileName(String(d.file_name || ''));
    if (d.job_id) {
        req.setJobId(String(d.job_id));
    }
    setOptionalNumber(req, 'setEstimatedDurationMinutes', d.estimated_duration_minutes);
    setOptionalNumber(req, 'setEstimatedFilamentConsumptionGrams', d.estimated_filament_consumption_grams);
    setOptionalNumber(req, 'setActualFilamentConsumptionGrams', d.actual_filament_consumption_grams);
    const started = optionalIsoTimestamp(d.started_at);
    const finished = optionalIsoTimestamp(d.finished_at);
    if (started) {
        req.setStartedAt(started);
    }
    if (finished) {
        req.setFinishedAt(finished);
    }
    if (d.status) {
        req.setStatus(String(d.status));
    }
    if (d.status_reason) {
        req.setStatusReason(String(d.status_reason));
    }
    setOptionalNumber(req, 'setObjectCount', d.object_count);
    setOptionalNumber(req, 'setPrintedCount', d.printed_count);
    if (Array.isArray(d.filaments)) {
        // The flag lets the backend tell an empty list from "not touching
        // filaments", which a repeated field alone cannot express.
        req.setFilamentsList(jobFilamentsFromRest(d.filaments));
        req.setFilamentsProvided(true);
    }
    const meta = metadataToJson(d.metadata);
    if (meta) {
        req.setMetadataJson(meta);
    }
}

export function buildCreateJobRequest(data) {
    const { CreateJobRequest } = require('./proto/acompanha/jobs/v1/jobs_pb');
    const req = new CreateJobRequest();
    fillJobMutation(req, data);
    return req;
}

export function buildUpdateJobRequest(uuid, data) {
    const { UpdateJobRequest } = require('./proto/acompanha/jobs/v1/jobs_pb');
    const req = new UpdateJobRequest();
    req.setUuid(String(uuid));
    fillJobMutation(req, data);
    return req;
}

function fillPrinterMutation(req, data) {
    const d = data || {};
    req.setName(String(d.name || ''));
    req.setBrand(String(d.brand || ''));
    req.setModel(String(d.model || ''));
    if (d.printer_model_uuid) {
        req.setPrinterModelUuid(String(d.printer_model_uuid));
    }
    req.setPowerConsumptionWatts(Number(d.power_consumption_watts ?? d.consumption) || 0);
    if (d.avg_consumption_watts != null && d.avg_consumption_watts !== '') {
        req.setAvgConsumptionWatts(Number(d.avg_consumption_watts) || 0);
    }
    req.setAcquisitionValue(Number(d.acquisition_value ?? d.price) || 0);
    const acquisitionDate = optionalIsoTimestamp(d.acquisition_date);
    if (acquisitionDate) {
        req.setAcquisitionDate(acquisitionDate);
    }
    req.setHourlyPrintingCost(Number(d.hourly_printing_cost) || 0);
    if (d.active != null) {
        req.setActive(Boolean(d.active));
    }
}

export function buildCreatePrinterRequest(data) {
    const { CreatePrinterRequest } = require('./proto/acompanha/printers/v1/printers_pb');
    const req = new CreatePrinterRequest();
    fillPrinterMutation(req, data);
    return req;
}

export function buildUpdatePrinterRequest(uuid, data) {
    const { UpdatePrinterRequest } = require('./proto/acompanha/printers/v1/printers_pb');
    const req = new UpdatePrinterRequest();
    req.setUuid(String(uuid));
    fillPrinterMutation(req, data);
    return req;
}

function fillFilamentMutation(req, data) {
    const d = data || {};
    req.setType(String(d.type || ''));
    req.setColor(String(d.color || ''));
    req.setColorLabel(String(d.color_label || ''));
    req.setBrand(String(d.brand || ''));
    req.setSpoolWeight(Number(d.spool_weight) || 0);
    req.setCurrentWeight(Number(d.current_weight) || 0);
    req.setCost(Number(d.cost ?? d.cost_per_kilogram) || 0);
}

export function buildCreateFilamentRequest(data) {
    const { CreateFilamentRequest } = require('./proto/acompanha/filaments/v1/filaments_pb');
    const req = new CreateFilamentRequest();
    fillFilamentMutation(req, data);
    const quantity = Number(data?.quantity);
    if (Number.isFinite(quantity) && quantity > 1) {
        req.setQuantity(quantity);
    }
    return req;
}

export function buildListFilamentUsagesRequest(filamentUuid, query) {
    const { ListFilamentUsagesRequest } = require('./proto/acompanha/filaments/v1/filaments_pb');
    const req = new ListFilamentUsagesRequest();
    req.setFilamentUuid(String(filamentUuid || ''));
    req.setPagination(paginationFromQuery(query || {}));
    return req;
}

export function buildUpdateFilamentRequest(uuid, data) {
    const { UpdateFilamentRequest } = require('./proto/acompanha/filaments/v1/filaments_pb');
    const req = new UpdateFilamentRequest();
    req.setUuid(String(uuid));
    fillFilamentMutation(req, data);
    return req;
}

function fillReplacementPartMutation(req, data) {
    const d = data || {};
    req.setName(String(d.name || '').trim());
    req.setUnitValueCents(Number(d.unit_value_cents) || 0);
    req.setQuantity(Number(d.quantity) || 0);
    req.setPrinterBrand(String(d.printer_brand || '').trim());
    req.setPrinterModel(String(d.printer_model || '').trim());
}

export function buildListReplacementPartsRequest(query) {
    const { ListReplacementPartsRequest } = require('./proto/acompanha/replacement_parts/v1/replacement_parts_pb');
    const req = new ListReplacementPartsRequest();
    req.setPagination(buildPaginationRequest(query));
    if (query?.printer_brand) {
        req.setPrinterBrand(String(query.printer_brand));
        req.setPrinterModel(String(query.printer_model || ''));
    }
    const outOfStock = query?.out_of_stock ?? query?.out_of_stock_only;
    if (outOfStock === true || outOfStock === 1 || outOfStock === '1') {
        req.setOutOfStockOnly(true);
    } else {
        const inStock = query?.in_stock ?? query?.in_stock_only;
        if (inStock === true || inStock === 1 || inStock === '1') {
            req.setInStockOnly(true);
        }
    }
    return req;
}

function fillOperationalCostMutation(req, data) {
    const d = data || {};
    req.setName(String(d.name || '').trim());
    req.setCategory(String(d.category || '').trim());
    req.setAmountCents(Number(d.amount_cents) || 0);
    req.setRecurrence(String(d.recurrence || 'recurring').trim() || 'recurring');
    req.setNotes(String(d.notes || '').trim());
    if (typeof req.setFrequency === 'function') {
        req.setFrequency(String(d.frequency || 'monthly').trim() || 'monthly');
    }
}

export function buildListOperationalCostsRequest(query) {
    const { ListOperationalCostsRequest } = require('./proto/acompanha/operational_costs/v1/operational_costs_pb');
    const req = new ListOperationalCostsRequest();
    req.setPagination(buildPaginationRequest(query));
    if (query?.recurrence) {
        req.setRecurrence(String(query.recurrence));
    }
    if (query?.category) {
        req.setCategory(String(query.category));
    }
    if (query?.archived && typeof req.setArchived === 'function') {
        req.setArchived(String(query.archived));
    }
    return req;
}

export function buildCreateOperationalCostRequest(data) {
    const { CreateOperationalCostRequest } = require('./proto/acompanha/operational_costs/v1/operational_costs_pb');
    const req = new CreateOperationalCostRequest();
    fillOperationalCostMutation(req, data);
    return req;
}

export function buildUpdateOperationalCostRequest(uuid, data) {
    const { UpdateOperationalCostRequest } = require('./proto/acompanha/operational_costs/v1/operational_costs_pb');
    const req = new UpdateOperationalCostRequest();
    req.setUuid(String(uuid));
    fillOperationalCostMutation(req, data);
    return req;
}

export function buildCreateReplacementPartRequest(data) {
    const { CreateReplacementPartRequest } = require('./proto/acompanha/replacement_parts/v1/replacement_parts_pb');
    const req = new CreateReplacementPartRequest();
    fillReplacementPartMutation(req, data);
    return req;
}

export function buildUpdateReplacementPartRequest(uuid, data) {
    const { UpdateReplacementPartRequest } = require('./proto/acompanha/replacement_parts/v1/replacement_parts_pb');
    const req = new UpdateReplacementPartRequest();
    req.setUuid(String(uuid));
    fillReplacementPartMutation(req, data);
    return req;
}

function fillPrinterModelMutation(req, data) {
    const d = data || {};
    req.setBrand(String(d.brand || '').trim());
    req.setModel(String(d.model || '').trim());
    req.setAvgConsumptionWatts(Number(d.avg_consumption_watts) || 0);
    req.setMaxConsumptionWatts(Number(d.max_consumption_watts) || 0);
    req.setFarmLinkSupported(Boolean(d.farm_link_supported));
    req.setExperimental(d.experimental != null ? Boolean(d.experimental) : true);
    req.setMaintenanceTasksList(buildMaintenanceTaskList(d.maintenance_tasks));
}

function buildMaintenanceTaskList(rows) {
    const { MaintenanceTask } = require('./proto/acompanha/printer_models/v1/printer_models_pb');
    return (Array.isArray(rows) ? rows : [])
        .map((row) => {
            const key = String(row?.task_key || '').trim();
            const hours = Number(row?.interval_hours) || 0;
            const days = Number(row?.interval_days) || 0;
            if (!key || (hours <= 0 && days <= 0)) {
                return null;
            }
            const task = new MaintenanceTask();
            task.setTaskKey(key);
            task.setIntervalHours(hours);
            task.setIntervalDays(days);
            return task;
        })
        .filter(Boolean);
}

export function buildListPrinterModelsRequest(query) {
    const { ListPrinterModelsRequest } = require('./proto/acompanha/printer_models/v1/printer_models_pb');
    const req = new ListPrinterModelsRequest();
    req.setPagination(buildPaginationRequest(query));
    if (query?.brand) {
        req.setBrand(String(query.brand));
    }
    if (query?.farm_link_support) {
        req.setFarmLinkSupport(String(query.farm_link_support));
    }
    if (query?.experimental) {
        req.setExperimental(String(query.experimental));
    }
    return req;
}

export function buildCreatePrinterModelRequest(data) {
    const { CreatePrinterModelRequest } = require('./proto/acompanha/printer_models/v1/printer_models_pb');
    const req = new CreatePrinterModelRequest();
    fillPrinterModelMutation(req, data);
    return req;
}

export function buildUpdatePrinterModelRequest(uuid, data) {
    const { UpdatePrinterModelRequest } = require('./proto/acompanha/printer_models/v1/printer_models_pb');
    const req = new UpdatePrinterModelRequest();
    req.setUuid(String(uuid));
    fillPrinterModelMutation(req, data);
    return req;
}

export function buildCreateSalesChannelRequest(data) {
    const { CreateSalesChannelRequest } = require('./proto/acompanha/sales_channels/v1/sales_channels_pb');
    const req = new CreateSalesChannelRequest();
    fillSalesChannelMutation(req, data);
    return req;
}

export function buildUpdateSalesChannelRequest(uuid, data) {
    const { UpdateSalesChannelRequest } = require('./proto/acompanha/sales_channels/v1/sales_channels_pb');
    const req = new UpdateSalesChannelRequest();
    req.setUuid(String(uuid));
    fillSalesChannelMutation(req, data);
    return req;
}

function fillSalesChannelMutation(req, data) {
    const d = data || {};
    req.setName(String(d.name || ''));
    if (d.commission_percent != null && d.commission_percent !== '') {
        req.setCommissionPercent(Number(d.commission_percent));
    }
    if (d.fixed_fee != null && d.fixed_fee !== '') {
        req.setFixedFee(Number(d.fixed_fee));
    }
    if (d.payment_fee_percent != null && d.payment_fee_percent !== '') {
        req.setPaymentFeePercent(Number(d.payment_fee_percent));
    }
    if (d.min_fee != null && d.min_fee !== '') {
        req.setMinFee(Number(d.min_fee));
    }
    if (d.dispatch_days != null && d.dispatch_days !== '') {
        req.setDispatchDays(Number(d.dispatch_days));
    }
    if (d.notes) {
        req.setNotes(String(d.notes));
    }
    if (typeof req.setRequiresExternalOrderId === 'function' && d.requires_external_order_id != null) {
        req.setRequiresExternalOrderId(Boolean(d.requires_external_order_id));
    }
    if (typeof req.setKind === 'function' && d.kind) {
        req.setKind(String(d.kind));
    }
    if (typeof req.setHoldsPayout === 'function' && d.holds_payout != null) {
        req.setHoldsPayout(Boolean(d.holds_payout));
    }
}

export function buildCreatePaymentFeeRequest(data) {
    const { CreatePaymentFeeRequest } = require('./proto/acompanha/payment_fees/v1/payment_fees_pb');
    const req = new CreatePaymentFeeRequest();
    fillPaymentFeeMutation(req, data);
    return req;
}

export function buildUpdatePaymentFeeRequest(uuid, data) {
    const { UpdatePaymentFeeRequest } = require('./proto/acompanha/payment_fees/v1/payment_fees_pb');
    const req = new UpdatePaymentFeeRequest();
    req.setUuid(String(uuid));
    fillPaymentFeeMutation(req, data);
    return req;
}

function fillPaymentFeeMutation(req, data) {
    const d = data || {};
    req.setPaymentMethod(String(d.payment_method || ''));
    if (d.fee_percent != null && d.fee_percent !== '') {
        req.setFeePercent(Number(d.fee_percent));
    }
    req.setValidFrom(String(d.valid_from || ''));
    req.setValidTo(d.valid_to ? String(d.valid_to) : '');
    if (d.notes) {
        req.setNotes(String(d.notes));
    }
}

function fillProductMutation(req, data) {
    const d = data || {};
    req.setName(String(d.name || ''));
    req.setDescription(String(d.description || ''));
    const images = [];
    if (Array.isArray(d.images)) {
        d.images.forEach((img) => {
            if (img) {
                images.push(String(img));
            }
        });
    }
    if (d.image) {
        images.push(String(d.image));
    }
    if (images.length) {
        req.setImagesList(images);
    }
    if (d.cost_price != null) {
        req.setCostPrice(Number(d.cost_price));
    }
    const selling = d.selling_price ?? d.base_price;
    if (selling != null) {
        req.setSellingPrice(Number(selling));
    }
    if (d.base_price != null) {
        req.setBasePrice(Number(d.base_price));
    }
    const measuresJson = measuresToJson(d.measures ?? d.measurements);
    if (measuresJson) {
        req.setMeasures(measuresJson);
        req.setMeasurements(measuresJson);
    }
    const lead = d.fabrication_lead_time_days
        ?? d.availability?.lead_time_for_order;
    const leadDays = Number(lead);
    req.setFabricationLeadTimeDays(
        Number.isFinite(leadDays) && leadDays > 0 ? Math.trunc(leadDays) : 1,
    );
    if (d.is_customizable != null) {
        req.setIsCustomizable(Boolean(d.is_customizable));
    }
    if (d.assembly_required != null) {
        req.setAssemblyRequired(Boolean(d.assembly_required));
    }
    if (d.stock_quantity != null) {
        req.setStockQuantity(Number(d.stock_quantity));
    }
    if (d.total_sales_quantity != null) {
        req.setTotalSalesQuantity(Number(d.total_sales_quantity));
    }
    if (typeof req.setKind === 'function' && d.kind) {
        req.setKind(String(d.kind));
    }
}

export function buildCreateProductRequest(data) {
    const { CreateProductRequest } = require('./proto/acompanha/products/v1/products_pb');
    const req = new CreateProductRequest();
    fillProductMutation(req, data);
    return req;
}

export function buildUpdateProductRequest(uuid, data) {
    const { UpdateProductRequest } = require('./proto/acompanha/products/v1/products_pb');
    const req = new UpdateProductRequest();
    req.setUuid(String(uuid));
    fillProductMutation(req, data);
    return req;
}

export function buildAdjustProductStockRequest(uuid, data) {
    const { AdjustProductStockRequest } = require('./proto/acompanha/products/v1/products_pb');
    const req = new AdjustProductStockRequest();
    req.setUuid(String(uuid));
    req.setDelta(parseInt(data?.delta, 10) || 0);
    return req;
}

function fillCustomerMutation(req, data) {
    const d = data || {};
    req.setName(String(d.name || ''));
    if (d.phone != null) {
        req.setPhone(String(d.phone));
    }
    if (d.email != null) {
        req.setEmail(String(d.email));
    }
    const doc = d.document ?? d.document_number;
    if (doc != null) {
        req.setDocument(String(doc));
        req.setDocumentNumber(String(doc));
    }
    if (d.address != null) {
        req.setStreet(String(d.address));
    }
    if (d.address_number != null) {
        req.setNumber(String(d.address_number));
    }
    if (d.address_complement != null) {
        req.setComplement(String(d.address_complement));
    }
    if (d.neighborhood != null) {
        req.setNeighborhood(String(d.neighborhood));
    }
    if (d.city != null) {
        req.setCity(String(d.city));
    }
    if (d.state != null) {
        req.setState(String(d.state));
    }
    if (d.zip_code != null) {
        req.setZipCode(String(d.zip_code));
    }
    if (d.category != null) {
        req.setCategory(String(d.category));
    }
    if (typeof req.setOriginSalesChannelUuid === 'function' && d.origin_sales_channel_uuid != null) {
        req.setOriginSalesChannelUuid(String(d.origin_sales_channel_uuid || ''));
    }
    if (typeof req.setOriginSalesChannelName === 'function' && d.origin_sales_channel_name != null) {
        req.setOriginSalesChannelName(String(d.origin_sales_channel_name || ''));
    }
}

export function buildCreateCustomerRequest(data) {
    const { CreateCustomerRequest } = require('./proto/acompanha/customers/v1/customers_pb');
    const req = new CreateCustomerRequest();
    fillCustomerMutation(req, data);
    return req;
}

export function buildUpdateCustomerRequest(uuid, data) {
    const { UpdateCustomerRequest } = require('./proto/acompanha/customers/v1/customers_pb');
    const req = new UpdateCustomerRequest();
    req.setUuid(String(uuid));
    fillCustomerMutation(req, data);
    return req;
}

export function buildCheckoutMutationRequest(RequestClass, uuid, data) {
    const req = new RequestClass();
    if (uuid) {
        req.setUuid(String(uuid));
    }
    const customer = customerRefFromRest(data.customer);
    if (customer) {
        req.setCustomer(customer);
    }
    const shipping = shippingMethodRefFromRest(data.shipping_method);
    if (shipping) {
        req.setShippingMethod(shipping);
    }
    if (Array.isArray(data.products)) {
        req.setProductsList(data.products.map(checkoutProductFromRest).filter(Boolean));
    }
    if (data.amount != null) {
        req.setAmount(Number(data.amount));
    }
    const channel = salesChannelRefFromRest(data.sales_channel);
    if (channel) {
        req.setSalesChannel(channel);
    }
    if (data.finish_order != null) {
        req.setFinishOrder(Boolean(data.finish_order));
    }
    if (Array.isArray(data.payment_methods)) {
        req.setPaymentMethodsList(data.payment_methods.map(paymentMethodFromRest).filter(Boolean));
    }
    const details = paymentDetailsFromRest(data.payment_details);
    if (details) {
        req.setPaymentDetails(details);
    }
    if (typeof req.setObservations === 'function' && data.observations != null) {
        req.setObservations(String(data.observations));
    }
    if (typeof req.setCommission === 'function' && data.commission != null) {
        req.setCommission(Number(data.commission) || 0);
    }
    if (typeof req.setDiscount === 'function' && data.discount != null) {
        req.setDiscount(Number(data.discount) || 0);
    }
    if (typeof req.setDiscountReason === 'function' && data.discount_reason != null) {
        req.setDiscountReason(String(data.discount_reason || ''));
    }
    if (typeof req.setExternalOrderId === 'function' && data.external_order_id != null) {
        req.setExternalOrderId(String(data.external_order_id || ''));
    }
    if (typeof req.setExternalOrderUrl === 'function' && data.external_order_url != null) {
        req.setExternalOrderUrl(String(data.external_order_url || ''));
    }
    return req;
}

export function buildCreateCheckoutRequest(data) {
    const { CreateCheckoutRequest } = require('./proto/acompanha/checkouts/v1/checkouts_pb');
    const req = buildCheckoutMutationRequest(CreateCheckoutRequest, null, data);
    const ts = optionalIsoTimestamp(data.created_at);
    if (ts) {
        req.setCreatedAt(ts);
    }
    return req;
}

export function buildUpdateCheckoutRequest(uuid, data) {
    const { UpdateCheckoutRequest } = require('./proto/acompanha/checkouts/v1/checkouts_pb');
    return buildCheckoutMutationRequest(UpdateCheckoutRequest, uuid, data);
}

function fillTransactionMutation(req, data) {
    const d = data || {};
    req.setType(String(d.type || ''));
    req.setAmount(Number(d.amount) || 0);
    req.setNetAmount(Number(d.net_amount) || 0);
    req.setDeduction(Number(d.deduction) || 0);
    req.setDescription(String(d.description || ''));
    req.setPaymentMethod(String(d.payment_method || ''));
    req.setOrderId(String(d.order_id || ''));
    if (typeof req.setAuthorizationId === 'function') {
        req.setAuthorizationId(String(d.authorization_id || ''));
    }
    if (typeof req.setSource === 'function') {
        req.setSource(String(d.source || ''));
    }
    if (typeof req.setOutcomeCategory === 'function') {
        req.setOutcomeCategory(String(d.outcome_category || ''));
    }
    if (typeof req.setCreatedAt === 'function') {
        const ts = optionalIsoTimestamp(d.created_at);
        if (ts) {
            req.setCreatedAt(ts);
        }
    }
}

export function buildCreateTransactionRequest(data) {
    const { CreateTransactionRequest } = require('./proto/acompanha/transactions/v1/transactions_pb');
    const req = new CreateTransactionRequest();
    fillTransactionMutation(req, data);
    return req;
}

export function buildUpdateTransactionRequest(uuid, data) {
    const { UpdateTransactionRequest } = require('./proto/acompanha/transactions/v1/transactions_pb');
    const req = new UpdateTransactionRequest();
    req.setUuid(String(uuid));
    fillTransactionMutation(req, data);
    return req;
}

function fillMaintenanceMutation(req, data) {
    const d = data || {};
    req.setPrinterUuid(String(d.printer_uuid || ''));
    req.setType(String(d.type || ''));
    req.setProblemDescription(String(d.problem_description || ''));
    const occurred = optionalIsoTimestamp(d.occurred_at);
    if (occurred) {
        req.setOccurredAt(occurred);
    }
    req.setAnalysisDurationMinutes(Number(d.analysis_duration_minutes) || 0);
    req.setPerformedActions(String(d.performed_actions || ''));
    req.setPrinterHoursCount(Number(d.printer_hours_count) || 0);
    req.setReplacementPartsList(replacementPartsFromRest(d.replacement_parts));
    req.setCorrectionDurationMinutes(Number(d.correction_duration_minutes) || 0);
}

export function buildCreateMaintenanceRequest(data) {
    const { CreateMaintenanceRequest } = require('./proto/acompanha/printer_maintenances/v1/printer_maintenances_pb');
    const req = new CreateMaintenanceRequest();
    fillMaintenanceMutation(req, data);
    return req;
}

export function buildUpdateMaintenanceRequest(uuid, data) {
    const { UpdateMaintenanceRequest } = require('./proto/acompanha/printer_maintenances/v1/printer_maintenances_pb');
    const req = new UpdateMaintenanceRequest();
    req.setUuid(String(uuid));
    fillMaintenanceMutation(req, data);
    return req;
}

export function buildListMaintenancesRequest(query) {
    const { ListMaintenancesRequest } = require('./proto/acompanha/printer_maintenances/v1/printer_maintenances_pb');
    const req = new ListMaintenancesRequest();
    req.setPagination(buildPaginationRequest(query));
    if (query.printer_uuid) {
        req.setPrinterUuid(String(query.printer_uuid));
    }
    if (query.type) {
        req.setType(String(query.type));
    }
    const from = optionalIsoTimestamp(query.occurred_from);
    const to = optionalIsoTimestamp(query.occurred_to);
    if (from) {
        req.setOccurredFrom(from);
    }
    if (to) {
        req.setOccurredTo(to);
    }
    return req;
}

export function buildListOrdersRequest(query) {
    const { ListOrdersRequest } = require('./proto/acompanha/orders/v1/orders_pb');
    const req = new ListOrdersRequest();
    req.setPagination(buildPaginationRequest(query));
    const from = optionalIsoTimestamp(query.from);
    const to = optionalIsoTimestamp(query.to);
    if (from) {
        req.setFrom(from);
    }
    if (to) {
        req.setTo(to);
    }
    if (query.sales_channel_id) {
        req.setSalesChannelId(String(query.sales_channel_id));
    }
    if (query.customer_uuid) {
        req.setCustomerUuid(String(query.customer_uuid));
    }
    if (query.production_status && typeof req.setProductionStatus === 'function') {
        req.setProductionStatus(String(query.production_status));
    }
    if (query.logistics_status && typeof req.setLogisticsStatus === 'function') {
        req.setLogisticsStatus(String(query.logistics_status));
    }
    if (query.payout_status && typeof req.setPayoutStatus === 'function') {
        req.setPayoutStatus(String(query.payout_status));
    }
    if (query.payment_status && typeof req.setPaymentStatus === 'function') {
        req.setPaymentStatus(String(query.payment_status));
    }
    if (query.completed && typeof req.setCompleted === 'function') {
        req.setCompleted(String(query.completed));
    }
    return req;
}

export function buildUpdateOrderStagesRequest(uuid, data) {
    const { UpdateOrderStagesRequest } = require('./proto/acompanha/orders/v1/orders_pb');
    const req = new UpdateOrderStagesRequest();
    req.setUuid(String(uuid || ''));
    req.setLane(String(data?.lane || ''));
    req.setStatus(String(data?.status || ''));
    return req;
}

export function buildPayOrderRequest(uuid, data) {
    const { PayOrderRequest } = require('./proto/acompanha/orders/v1/orders_pb');
    const req = new PayOrderRequest();
    req.setUuid(String(uuid || ''));
    req.setPaymentMethod(String(data?.payment_method || ''));
    req.setInstallments(Math.max(1, Number(data?.installments) || 1));
    const ts = optionalIsoTimestamp(data?.payment_date);
    if (ts) {
        req.setPaymentDate(ts);
    }
    return req;
}

export function buildUpdateOrderCommissionRequest(uuid, data) {
    const { UpdateOrderCommissionRequest } = require('./proto/acompanha/orders/v1/orders_pb');
    const req = new UpdateOrderCommissionRequest();
    req.setUuid(String(uuid || ''));
    req.setCommission(Math.max(0, Number(data?.commission) || 0));
    return req;
}

export function buildListTransactionsRequest(query) {
    const { ListTransactionsRequest } = require('./proto/acompanha/transactions/v1/transactions_pb');
    const req = new ListTransactionsRequest();
    req.setPagination(buildPaginationRequest(query));
    const from = optionalIsoTimestamp(query.from);
    const to = optionalIsoTimestamp(query.to);
    if (from) {
        req.setFrom(from);
    }
    if (to) {
        req.setTo(to);
    }
    if (query.type) {
        req.setType(String(query.type));
    }
    const authRaw = query.authorization_ids;
    if (authRaw) {
        const ids = Array.isArray(authRaw)
            ? authRaw
            : String(authRaw).split(',');
        const cleaned = [...new Set(ids.map((id) => String(id || '').trim()).filter(Boolean))];
        if (cleaned.length && typeof req.setAuthorizationIdsList === 'function') {
            req.setAuthorizationIdsList(cleaned);
        }
    }
    return req;
}

export function buildReconciliationRequest(query = {}) {
    const { ReconciliationRequest } = require('./proto/acompanha/transactions/v1/transactions_pb');
    const req = new ReconciliationRequest();
    const from = optionalIsoTimestamp(query.from);
    const to = optionalIsoTimestamp(query.to);
    if (from) {
        req.setFrom(from);
    }
    if (to) {
        req.setTo(to);
    }
    if (query.type) {
        req.setType(String(query.type));
    }
    const q = String(query.q || query.search || '').trim();
    if (q) {
        req.setQ(q);
    }
    return req;
}

export function buildListAppNotificationsRequest(query) {
    const { ListAppNotificationsRequest } = require('./proto/acompanha/app_notifications/v1/app_notifications_pb');
    const req = new ListAppNotificationsRequest();
    req.setPagination(buildPaginationRequest(query));
    const unread = query?.unread;
    req.setUnreadOnly(unread === '1' || unread === 1 || unread === true || String(unread).toLowerCase() === 'true');
    return req;
}

export function buildListSentAppNotificationsRequest(query) {
    const { ListSentAppNotificationsRequest } = require('./proto/acompanha/app_notifications/v1/app_notifications_pb');
    const req = new ListSentAppNotificationsRequest();
    req.setPagination(buildPaginationRequest(query));
    const search = String(query?.q || query?.search || '').trim();
    if (search) {
        req.setSearch(search);
    }
    return req;
}

export function buildListTicketsRequest(query) {
    const { ListTicketsRequest } = require('./proto/acompanha/tickets/v1/tickets_pb');
    const req = new ListTicketsRequest();
    req.setPagination(buildPaginationRequest(query));
    if (query?.status) {
        req.setStatus(String(query.status));
    }
    if (query?.category) {
        req.setCategory(String(query.category));
    }
    if (query?.channel) {
        req.setChannel(String(query.channel));
    }
    const search = String(query?.q || query?.search || '').trim();
    if (search) {
        req.setSearch(search);
    }
    return req;
}

export function buildCreateAppNotificationRequest(data) {
    const { CreateAppNotificationRequest } = require('./proto/acompanha/app_notifications/v1/app_notifications_pb');
    const req = new CreateAppNotificationRequest();
    const d = data || {};
    req.setTitle(String(d.title || '').trim());
    req.setBody(String(d.body || '').trim());
    if (d.link) {
        req.setLink(String(d.link).trim());
    }
    req.setBroadcast(Boolean(d.broadcast));
    if (!d.broadcast && d.target_user_uuid) {
        req.setTargetUserUuid(String(d.target_user_uuid).trim());
    }
    const plans = Array.isArray(d.target_plan_names)
        ? d.target_plan_names.map((name) => String(name || '').trim()).filter(Boolean)
        : [];
    if (!d.broadcast && plans.length > 0) {
        req.setTargetPlanNamesList(plans);
    }
    req.setNotifyImmediately(Boolean(d.notify_immediately));
    return req;
}

function fillDesktopReleaseMutation(req, data) {
    const d = data || {};
    req.setVersion(String(d.version || '').trim());
    req.setTitle(String(d.title || '').trim());
    req.setChangelog(String(d.changelog || '').trim());
    req.setDownloadWindows(String(d.download_windows || '').trim());
    req.setDownloadMac(String(d.download_mac || '').trim());
    req.setDownloadLinux(String(d.download_linux || '').trim());
    if (d.active != null) {
        req.setActive(Boolean(d.active));
    }
}

export function buildCreateDesktopReleaseRequest(data) {
    const { CreateDesktopReleaseRequest } = require('./proto/acompanha/desktop_releases/v1/desktop_releases_pb');
    const req = new CreateDesktopReleaseRequest();
    fillDesktopReleaseMutation(req, data);
    return req;
}

export function buildUpdateDesktopReleaseRequest(uuid, data) {
    const { UpdateDesktopReleaseRequest } = require('./proto/acompanha/desktop_releases/v1/desktop_releases_pb');
    const req = new UpdateDesktopReleaseRequest();
    req.setUuid(String(uuid));
    fillDesktopReleaseMutation(req, data);
    return req;
}

function fillTutorialVideoMutation(req, data) {
    const d = data || {};
    req.setName(String(d.name || '').trim());
    req.setDesktopUrl(String(d.desktop_url || '').trim());
    req.setMobileUrl(String(d.mobile_url || '').trim());
    req.setSection(String(d.section || '').trim());
    if (typeof req.setPageKeysList === 'function') {
        req.setPageKeysList(Array.isArray(d.page_keys) ? d.page_keys.map(String) : []);
    }
}

export function buildListTutorialVideosRequest(query) {
    const { ListTutorialVideosRequest } = require('./proto/acompanha/tutorial_videos/v1/tutorial_videos_pb');
    const req = new ListTutorialVideosRequest();
    if (query?.page_key) {
        req.setPageKey(String(query.page_key));
    }
    if (query?.section) {
        req.setSection(String(query.section));
    }
    return req;
}

export function buildCreateTutorialVideoRequest(data) {
    const { CreateTutorialVideoRequest } = require('./proto/acompanha/tutorial_videos/v1/tutorial_videos_pb');
    const req = new CreateTutorialVideoRequest();
    fillTutorialVideoMutation(req, data);
    return req;
}

export function buildUpdateTutorialVideoRequest(uuid, data) {
    const { UpdateTutorialVideoRequest } = require('./proto/acompanha/tutorial_videos/v1/tutorial_videos_pb');
    const req = new UpdateTutorialVideoRequest();
    req.setUuid(String(uuid));
    fillTutorialVideoMutation(req, data);
    return req;
}

export function buildReorderTutorialVideosRequest(data) {
    const { ReorderTutorialVideosRequest } = require('./proto/acompanha/tutorial_videos/v1/tutorial_videos_pb');
    const req = new ReorderTutorialVideosRequest();
    req.setSection(String(data?.section || '').trim());
    req.setOrderedUuidsList(Array.isArray(data?.ordered_uuids) ? data.ordered_uuids.map(String) : []);
    return req;
}

function decodeAttachmentBytes(raw) {
    if (!raw) {
        return null;
    }
    if (raw instanceof Uint8Array) {
        return raw;
    }
    if (ArrayBuffer.isView(raw)) {
        return new Uint8Array(raw.buffer, raw.byteOffset, raw.byteLength);
    }
    if (raw instanceof ArrayBuffer) {
        return new Uint8Array(raw);
    }
    if (typeof raw === 'string') {
        const binary = atob(raw);
        const out = new Uint8Array(binary.length);
        for (let i = 0; i < binary.length; i += 1) {
            out[i] = binary.charCodeAt(i);
        }
        return out;
    }
    if (Array.isArray(raw)) {
        return Uint8Array.from(raw);
    }
    return null;
}

function buildTicketAttachmentInputs(files) {
    const { TicketAttachmentInput } = require('./proto/acompanha/tickets/v1/tickets_pb');
    const list = Array.isArray(files) ? files : [];
    return list.map((file) => {
        const input = new TicketAttachmentInput();
        input.setFileName(String(file?.file_name || file?.name || 'file'));
        input.setContentType(String(file?.content_type || file?.type || 'application/octet-stream'));
        const bytes = decodeAttachmentBytes(file?.data);
        if (bytes && bytes.length) {
            input.setData(bytes);
        }
        return input;
    }).filter((input) => {
        const data = typeof input.getData_asU8 === 'function' ? input.getData_asU8() : input.getData();
        return Boolean(data && data.length);
    });
}

export function buildCreateTicketRequest(data) {
    const { CreateTicketRequest } = require('./proto/acompanha/tickets/v1/tickets_pb');
    const req = new CreateTicketRequest();
    const d = data || {};
    req.setCategory(String(d.category || '').trim());
    req.setBody(String(d.body || '').trim());
    req.setChannel(String(d.channel || 'web').trim() || 'web');
    req.setFilesList(buildTicketAttachmentInputs(d.files));
    return req;
}

export function buildAddTicketMessageRequest(uuid, data) {
    const { AddTicketMessageRequest } = require('./proto/acompanha/tickets/v1/tickets_pb');
    const req = new AddTicketMessageRequest();
    const d = data || {};
    req.setUuid(String(uuid));
    req.setBody(String(d.body || '').trim());
    req.setFilesList(buildTicketAttachmentInputs(d.files));
    return req;
}

export function buildUpdateTicketStatusRequest(uuid, data) {
    const { UpdateTicketStatusRequest } = require('./proto/acompanha/tickets/v1/tickets_pb');
    const req = new UpdateTicketStatusRequest();
    req.setUuid(String(uuid));
    req.setStatus(String(data?.status || '').trim());
    return req;
}

export function buildProductsSummaryRequest(query) {
    const { GetProductsSummaryRequest } = require('./proto/acompanha/products/v1/products_pb');
    const req = new GetProductsSummaryRequest();
    if (query.q) {
        req.setQ(String(query.q));
    }
    return req;
}

export function buildOrdersSummaryRequest(query) {
    const { GetOrdersSummaryRequest } = require('./proto/acompanha/orders/v1/orders_pb');
    const req = new GetOrdersSummaryRequest();
    if (query.q) {
        req.setQ(String(query.q));
    }
    const from = optionalIsoTimestamp(query.from);
    const to = optionalIsoTimestamp(query.to);
    if (from) {
        req.setFrom(from);
    }
    if (to) {
        req.setTo(to);
    }
    if (query.sales_channel_id) {
        req.setSalesChannelId(String(query.sales_channel_id));
    }
    if (query.customer_uuid) {
        req.setCustomerUuid(String(query.customer_uuid));
    }
    return req;
}

function buildPartnerItemInputs(items, ItemInputCtor) {
    return (items || []).map((item) => {
        const row = new ItemInputCtor();
        row.setProductUuid(String(item.product_uuid || ''));
        row.setItemKind(String(item.item_kind || 'stock_product'));
        row.setMinInitialQty(Number(item.min_initial_qty) || 0);
        row.setMinReorderQty(Number(item.min_reorder_qty) || 0);
        row.setDisplayQty(Number(item.display_qty) || 0);
        row.setWholesaleCents(Number(item.wholesale_cents) || 0);
        row.setSuggestedRetailCents(Number(item.suggested_retail_cents) || 0);
        row.setConsignmentRepasseCents(Number(item.consignment_repasse_cents) || 0);
        return row;
    });
}

function buildPartnerLineInputs(lines, LineInputCtor) {
    return (lines || []).map((line) => {
        const row = new LineInputCtor();
        const sold = Number(line.sold_qty) || 0;
        const registerSale = line.register_sale !== false;
        const registerSaleQty = registerSale ? (Number(line.register_sale_qty) || sold) : 0;
        row.setProductUuid(String(line.product_uuid || ''));
        row.setSoldQty(sold);
        row.setRestockedQty(Number(line.restocked_qty) || 0);
        row.setOrderedQty(Number(line.ordered_qty) || 0);
        row.setQuantity(Number(line.quantity) || 0);
        if (typeof row.setRegisterSale === 'function') {
            row.setRegisterSale(registerSale);
        }
        if (typeof row.setRegisterSaleQty === 'function') {
            row.setRegisterSaleQty(registerSaleQty);
        }
        return row;
    });
}

export function buildListCommercePartnersRequest(query = {}) {
    const { ListCommercePartnersRequest } = require('./proto/acompanha/commerce_partners/v1/commerce_partners_pb');
    const { PaginationRequest } = require('./proto/acompanha/common/v1/common_pb');
    const req = new ListCommercePartnersRequest();
    const pagination = new PaginationRequest();
    pagination.setPage(Number(query.page) || 1);
    pagination.setLimit(Number(query.limit) || 20);
    if (query.q) {
        pagination.setQ(String(query.q));
    }
    req.setPagination(pagination);
    if (query.modality) {
        req.setModality(String(query.modality));
    }
    if (query.status) {
        req.setStatus(String(query.status));
    }
    return req;
}

export function buildListUsersRequest(query = {}) {
    const { ListUsersRequest } = require('./proto/acompanha/users/v1/users_pb');
    const req = new ListUsersRequest();
    req.setPagination(buildPaginationRequest({
        page: query.page || 1,
        limit: query.limit || 30,
        q: query.q || query.search || '',
    }));
    if (query.plan) {
        req.setPlan(String(query.plan));
    }
    if (query.sort_by) {
        req.setSortBy(String(query.sort_by));
    }
    if (query.sort_order) {
        req.setSortOrder(String(query.sort_order));
    }
    return req;
}

export function buildCreateUserRequest(data = {}) {
    const { CreateUserRequest } = require('./proto/acompanha/users/v1/users_pb');
    const req = new CreateUserRequest();
    if (data.uuid) {
        req.setUuid(String(data.uuid));
    }
    req.setName(String(data.name || '').trim());
    req.setEmail(String(data.email || '').trim());
    req.setPassword(String(data.password || ''));
    if (data.store_name != null) {
        req.setStoreName(String(data.store_name).trim());
    }
    if (data.subscription_uuid != null) {
        req.setSubscriptionUuid(String(data.subscription_uuid).trim());
    }
    if (typeof data.active === 'boolean') {
        req.setHasActive(true);
        req.setActive(data.active);
    }
    if (typeof data.subscription_active === 'boolean') {
        req.setHasSubscriptionActive(true);
        req.setSubscriptionActive(data.subscription_active);
    }
    return req;
}

export function buildUpdateUserRequest(uuid, data = {}) {
    const { UpdateUserRequest } = require('./proto/acompanha/users/v1/users_pb');
    const req = new UpdateUserRequest();
    req.setUuid(String(uuid || ''));
    if (data.name != null) {
        req.setName(String(data.name).trim());
    }
    if (data.email != null) {
        req.setEmail(String(data.email).trim());
    }
    if (data.password) {
        req.setPassword(String(data.password));
    }
    if (typeof data.active === 'boolean') {
        req.setHasActive(true);
        req.setActive(data.active);
    }
    if (Object.prototype.hasOwnProperty.call(data, 'store_name')) {
        req.setHasStoreName(true);
        req.setStoreName(String(data.store_name || '').trim());
    }
    if (Object.prototype.hasOwnProperty.call(data, 'subscription_uuid')) {
        req.setHasSubscriptionUuid(true);
        req.setSubscriptionUuid(String(data.subscription_uuid || '').trim());
    }
    if (typeof data.subscription_active === 'boolean') {
        req.setHasSubscriptionActive(true);
        req.setSubscriptionActive(data.subscription_active);
    }
    return req;
}

export function buildCreateCommercePartnerRequest(data = {}) {
    const {
        CreateCommercePartnerRequest,
        CommercePartnerItemInput,
    } = require('./proto/acompanha/commerce_partners/v1/commerce_partners_pb');
    const req = new CreateCommercePartnerRequest();
    req.setName(String(data.name || ''));
    req.setContactName(String(data.contact_name || ''));
    req.setContactPhone(String(data.contact_phone || ''));
    req.setContactEmail(String(data.contact_email || ''));
    req.setModality(String(data.modality || ''));
    req.setStatus(String(data.status || 'active'));
    req.setAddress(String(data.address || ''));
    req.setAddressNumber(String(data.address_number || ''));
    req.setAddressComplement(String(data.address_complement || ''));
    req.setNeighborhood(String(data.neighborhood || ''));
    req.setZipCode(String(data.zip_code || ''));
    req.setCity(String(data.city || ''));
    req.setState(String(data.state || ''));
    req.setVisitFrequency(String(data.visit_frequency || ''));
    req.setFirstVisitOn(String(data.first_visit_on || ''));
    req.setNotes(String(data.notes || ''));
    req.setItemsList(buildPartnerItemInputs(data.items, CommercePartnerItemInput));
    return req;
}

export function buildUpdateCommercePartnerRequest(uuid, data = {}) {
    const {
        UpdateCommercePartnerRequest,
        CommercePartnerItemInput,
    } = require('./proto/acompanha/commerce_partners/v1/commerce_partners_pb');
    const req = new UpdateCommercePartnerRequest();
    req.setUuid(String(uuid || ''));
    req.setName(String(data.name || ''));
    req.setContactName(String(data.contact_name || ''));
    req.setContactPhone(String(data.contact_phone || ''));
    req.setContactEmail(String(data.contact_email || ''));
    req.setModality(String(data.modality || ''));
    req.setStatus(String(data.status || 'active'));
    req.setAddress(String(data.address || ''));
    req.setAddressNumber(String(data.address_number || ''));
    req.setAddressComplement(String(data.address_complement || ''));
    req.setNeighborhood(String(data.neighborhood || ''));
    req.setZipCode(String(data.zip_code || ''));
    req.setCity(String(data.city || ''));
    req.setState(String(data.state || ''));
    req.setVisitFrequency(String(data.visit_frequency || ''));
    req.setFirstVisitOn(String(data.first_visit_on || ''));
    req.setNotes(String(data.notes || ''));
    req.setItemsList(buildPartnerItemInputs(data.items, CommercePartnerItemInput));
    return req;
}

export function buildUpdateFeatureFlagRequest(key, data = {}) {
    const { UpdateFeatureFlagRequest } = require('./proto/acompanha/feature_flags/v1/feature_flags_pb');
    const req = new UpdateFeatureFlagRequest();
    req.setKey(String(key || ''));
    req.setName(String(data.name || ''));
    req.setDescription(String(data.description || ''));
    req.setEnabled(Boolean(data.enabled));
    req.setIsBeta(Boolean(data.is_beta));
    req.setShowInMenu(Boolean(data.show_in_menu));
    req.setPlanNamesList(Array.isArray(data.plan_names) ? data.plan_names.map(String) : []);
    return req;
}

export function buildCreateFeatureFlagRequest(data = {}) {
    const { CreateFeatureFlagRequest } = require('./proto/acompanha/feature_flags/v1/feature_flags_pb');
    const req = new CreateFeatureFlagRequest();
    req.setKey(String(data.key || ''));
    req.setName(String(data.name || ''));
    req.setDescription(String(data.description || ''));
    req.setEnabled(Boolean(data.enabled));
    req.setIsBeta(data.is_beta !== false);
    req.setShowInMenu(Boolean(data.show_in_menu));
    req.setPlanNamesList(Array.isArray(data.plan_names) ? data.plan_names.map(String) : []);
    return req;
}

export function buildCreateBillingExemptionRequest(data = {}) {
    const { CreateBillingExemptionRequest } = require('./proto/acompanha/subscription_billing/v1/subscription_billing_pb');
    const req = new CreateBillingExemptionRequest();
    req.setUserUuid(String(data.user_uuid || ''));
    req.setReason(String(data.reason || ''));
    const raw = String(data.exempt_until || '').trim();
    if (raw) {
        const ts = /^\d{4}-\d{2}-\d{2}$/.test(raw)
            ? isoToTimestamp(`${raw}T23:59:59.000Z`)
            : optionalIsoTimestamp(raw);
        if (ts) {
            req.setExemptUntil(ts);
        }
    }
    return req;
}

export function buildMigratePlanRequest(data = {}) {
    const { MigratePlanRequest } = require('./proto/acompanha/account/v1/account_pb');
    const req = new MigratePlanRequest();
    req.setPlanUuid(String(data.plan_uuid || ''));
    return req;
}

export function buildSubmitSubscriptionPaymentProofRequest(data = {}) {
    const { SubmitSubscriptionPaymentProofRequest } = require('./proto/acompanha/account/v1/account_pb');
    const req = new SubmitSubscriptionPaymentProofRequest();
    req.setReceipt(String(data.receipt || ''));
    return req;
}

export function buildAttachSubscriptionChargeRequest(userUUID, data = {}) {
    const { AttachSubscriptionChargeRequest } = require('./proto/acompanha/subscription_billing/v1/subscription_billing_pb');
    const req = new AttachSubscriptionChargeRequest();
    req.setUserUuid(String(userUUID || ''));
    req.setBoleto(String(data.boleto || ''));
    const pix = String(data.pix_qr || data.pix || '');
    req.setPixQr(pix);
    return req;
}

function fillSubscriptionPlanMutation(req, data = {}) {
    req.setName(String(data.name || ''));
    req.setDescription(String(data.description || ''));
    req.setMonthlyBilledValue(Number(data.monthly_billed_value) || 0);
    req.setFeaturesList(Array.isArray(data.features) ? data.features.map(String) : []);

    req.setLimitsList(buildPlanLimits(data.limits));
}

function buildPlanLimits(limits) {
    if (!limits || typeof limits !== 'object') {
        return [];
    }
    const { PlanLimit } = require('./proto/acompanha/common/v1/common_pb');
    return Object.entries(limits)
        .filter(([, value]) => value != null && value !== '')
        .map(([key, value]) => {
            const limit = new PlanLimit();
            limit.setKey(String(key));
            limit.setValue(Number(value));
            return limit;
        });
}

export function buildCreateSubscriptionPlanRequest(data = {}) {
    const { CreateSubscriptionPlanRequest } = require('./proto/acompanha/subscription_plans/v1/subscription_plans_pb');
    const req = new CreateSubscriptionPlanRequest();
    fillSubscriptionPlanMutation(req, data);
    return req;
}

export function buildUpdateSubscriptionPlanRequest(uuid, data = {}) {
    const { UpdateSubscriptionPlanRequest } = require('./proto/acompanha/subscription_plans/v1/subscription_plans_pb');
    const req = new UpdateSubscriptionPlanRequest();
    req.setUuid(String(uuid || ''));
    fillSubscriptionPlanMutation(req, data);
    return req;
}

export function buildRejectSubscriptionPaymentRequest(uuid, data = {}) {
    const { RejectSubscriptionPaymentRequest } = require('./proto/acompanha/subscription_billing/v1/subscription_billing_pb');
    const req = new RejectSubscriptionPaymentRequest();
    req.setUuid(String(uuid || ''));
    req.setReason(String(data.reason || data.rejection_reason || ''));
    return req;
}

function quoteShippingOptionFromRest(data) {
    const { QuoteShippingOption } = require('./proto/acompanha/quotes/v1/quotes_pb');
    if (!data || typeof data !== 'object') {
        return null;
    }
    const opt = new QuoteShippingOption();
    opt.setName(String(data.name || ''));
    opt.setCost(Number(data.cost) || 0);
    opt.setDeliveryDays(Number(data.delivery_days) || 0);
    return opt;
}

function quotePaymentOptionFromRest(data) {
    const { QuotePaymentOption } = require('./proto/acompanha/quotes/v1/quotes_pb');
    if (!data || typeof data !== 'object') {
        return null;
    }
    const opt = new QuotePaymentOption();
    opt.setName(String(data.name || ''));
    opt.setInstallments(Number(data.installments) || 1);
    opt.setAmount(Number(data.amount) || 0);
    return opt;
}

function fillQuoteMutation(req, data = {}) {
    const customer = customerRefFromRest(data.customer || {
        id: data.customer_uuid,
        name: data.customer_name,
        phone: data.customer_phone,
        email: data.customer_email,
    });
    if (customer) {
        req.setCustomer(customer);
    }
    const products = (Array.isArray(data.products) ? data.products : [])
        .map(checkoutProductFromRest)
        .filter(Boolean);
    req.setProductsList(products);
    req.setAmount(Number(data.amount) || 0);
    req.setDiscount(Number(data.discount) || 0);
    if (typeof req.setDiscountReason === 'function') {
        req.setDiscountReason(String(data.discount_reason || ''));
    }
    req.setProductionDays(Number(data.production_days) || 0);
    req.setValidUntil(String(data.valid_until || ''));
    req.setObservations(String(data.observations || ''));
    req.setShippingOptionsList(
        (Array.isArray(data.shipping_options) ? data.shipping_options : [])
            .map(quoteShippingOptionFromRest)
            .filter(Boolean),
    );
    req.setPaymentOptionsList(
        (Array.isArray(data.payment_options) ? data.payment_options : [])
            .map(quotePaymentOptionFromRest)
            .filter(Boolean),
    );
}

export function buildCreateQuoteRequest(data = {}) {
    const { CreateQuoteRequest } = require('./proto/acompanha/quotes/v1/quotes_pb');
    const req = new CreateQuoteRequest();
    fillQuoteMutation(req, data);
    if (data.status) {
        req.setStatus(String(data.status));
    }
    return req;
}

export function buildUpdateQuoteRequest(uuid, data = {}) {
    const { UpdateQuoteRequest } = require('./proto/acompanha/quotes/v1/quotes_pb');
    const req = new UpdateQuoteRequest();
    req.setUuid(String(uuid || ''));
    fillQuoteMutation(req, data);
    return req;
}

export function buildUpdateQuoteStatusRequest(uuid, data = {}) {
    const { UpdateQuoteStatusRequest } = require('./proto/acompanha/quotes/v1/quotes_pb');
    const req = new UpdateQuoteStatusRequest();
    req.setUuid(String(uuid || ''));
    req.setStatus(String(data.status || ''));
    return req;
}

export function buildConvertQuoteToCheckoutRequest(uuid, data = {}) {
    const { ConvertQuoteToCheckoutRequest } = require('./proto/acompanha/quotes/v1/quotes_pb');
    const req = new ConvertQuoteToCheckoutRequest();
    req.setUuid(String(uuid || ''));
    req.setShippingOptionIndex(Number(data.shipping_option_index) || 0);
    const channel = salesChannelRefFromRest(data.sales_channel);
    if (channel) {
        req.setSalesChannel(channel);
    }
    return req;
}

export { buildPartnerLineInputs };
